import { apiQuestions } from '@/lib';
import { useQuery } from 'react-query';
import { format, parseISO } from 'date-fns';

interface IQuiz {
  id: number;
  titulo: string;
  ativo: boolean;
  taxonomiaId: number;
  periodicidade: number;
  protocoloId: number;
  taxonomia: string;
  protocolo: string;
  isDeleted: boolean;
  deleterId?: string;
  questionarioDisparo: any[];
  deletionTime?: string;
  lastModificationTime?: string;
  lastModifierId?: string;
  creationTime: string;
  creatorId: string;
}

interface useGetQuestionsProps {
  filter?: string;
  instanciaId?: string;
}

const useGetQuestions = ({ filter, instanciaId }: useGetQuestionsProps) => {
  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ['questions', filter, instanciaId],
    queryFn: async () => {
      const res = await apiQuestions.get(`/protocolo`, {
        // params: {
        //   MaxResultCount: 999,
        //   instanciaId,
        // },
      });

      const dataRes = res.data;
      const formattedData = dataRes?.items?.map(
        (quiz: {
          id: any;
          nome: any;
          periodicidade: any;
          questionarioDisparo: any;
          ativo: any;
          creationTime: string;
        }) => {
          return {
            key: quiz.id,
            name: quiz.nome,
            periodicidade: quiz.periodicidade,
            disparos: quiz.questionarioDisparo,
            aplicacao: '',
            status: quiz.ativo,
            periodo: format(parseISO(quiz.creationTime), 'dd/MM/yyyy'),
          };
        },
      );

      return formattedData;
    },
  });

  return {
    data,
    isLoading,
    isError,
    refetch,
  };
};

export default useGetQuestions;
